import { render, staticRenderFns } from "./FulfillmentCard.vue?vue&type=template&id=a408adc6&"
import script from "./FulfillmentCard.vue?vue&type=script&lang=js&"
export * from "./FulfillmentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports